(() => {
  const instagramUrl = 'https://www.instagram.com/blacklist.co/';
  const shopAllUrl = '/pages/shop-all?view=blacklist-main-home-v10';
  const logoUrl = document.querySelector('meta[name="blacklist-b-logo"]')?.content || '';
  const maxQuantity = 10;
  const regions = [
    { flag: '🇮🇳', label: 'India', currency: 'INR', symbol: 'Rs.', rate: 1, decimals: 0 },
    { flag: '🇯🇵', label: 'Japan', currency: 'JPY', symbol: '¥', rate: 1.8, decimals: 0 },
    { flag: '🇰🇷', label: 'Korea', currency: 'KRW', symbol: '₩', rate: 16.3, decimals: 0 },
    { flag: '🇺🇸', label: 'USA', currency: 'USD', symbol: '$', rate: 0.012, decimals: 2 },
    { flag: '🇫🇷', label: 'France', currency: 'EUR', symbol: '€', rate: 0.011, decimals: 2 },
    { flag: '🇷🇺', label: 'Russia', currency: 'RUB', symbol: '₽', rate: 1.05, decimals: 0 }
  ];

  const ready = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  const money = (cents, region) => {
    const amount = (Number(cents || 0) / 100) * region.rate;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: region.currency,
        maximumFractionDigits: region.decimals,
        minimumFractionDigits: region.decimals
      }).format(amount);
    } catch {
      return `${region.symbol} ${amount.toFixed(region.decimals)}`;
    }
  };

  const getRegion = () => {
    const saved = window.localStorage?.getItem('blacklist-region');
    return regions.find((region) => region.currency === saved) || regions[0];
  };

  const setRegion = (region) => {
    window.localStorage?.setItem('blacklist-region', region.currency);
    document.querySelectorAll('[data-blacklist-active-currency]').forEach((node) => {
      node.textContent = `${region.flag} ${region.currency} (${region.symbol})`;
    });
    document.querySelectorAll('[data-region-option]').forEach((button) => {
      button.setAttribute('aria-current', button.dataset.currency === region.currency ? 'true' : 'false');
    });
    document.querySelectorAll('[data-blacklist-price][data-price-cents]').forEach((node) => {
      node.textContent = money(node.dataset.priceCents, region);
    });
  };

  const ensureRegionPanel = () => {
    let panel = document.querySelector('[data-blacklist-global-region]');
    if (panel) return panel;

    panel = document.createElement('section');
    panel.className = 'blacklist-region-panel';
    panel.setAttribute('data-blacklist-global-region', '');
    panel.hidden = true;
    panel.innerHTML = `
      <button class="blacklist-region-panel__backdrop" type="button" aria-label="Close region selector" data-region-close></button>
      <div class="blacklist-region-panel__card" role="dialog" aria-modal="true" aria-label="Choose region and currency">
        <button class="blacklist-region-panel__close" type="button" data-region-close>Close</button>
        <div class="blacklist-region-panel__top">
          <span>Auto detected currency</span>
          <strong data-blacklist-active-currency></strong>
        </div>
        <p>Select region</p>
        <div class="blacklist-region-panel__list">
          ${regions
            .map(
              (region) => `
                <button type="button" data-region-option data-currency="${region.currency}">
                  <span>${region.flag}</span>
                  <strong>${region.label}</strong>
                  <em>${region.currency} (${region.symbol})</em>
                </button>
              `
            )
            .join('')}
        </div>
      </div>
    `;
    document.body.appendChild(panel);
    panel.querySelectorAll('[data-region-close]').forEach((button) => {
      button.addEventListener('click', () => {
        panel.hidden = true;
      });
    });
    panel.querySelectorAll('[data-region-option]').forEach((button) => {
      button.addEventListener('click', () => {
        const region = regions.find((item) => item.currency === button.dataset.currency) || regions[0];
        setRegion(region);
        panel.hidden = true;
      });
    });
    setRegion(getRegion());
    return panel;
  };

  const fixInstagram = () => {
    document
      .querySelectorAll('a[href*="instagram.com"], a[aria-label*="Instagram" i], a[href*="blacklisthype"]')
      .forEach((link) => {
        link.href = instagramUrl;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
      });
  };

  const bindRegionLinks = () => {
    document
      .querySelectorAll('a[href="/localization"], a[href*="/localization"], a[aria-label*="Region" i], a[aria-label*="currency" i]')
      .forEach((link) => {
        if (link.dataset.blacklistRegionBound === 'true') return;
        link.dataset.blacklistRegionBound = 'true';
        link.addEventListener('click', (event) => {
          event.preventDefault();
          const panel = ensureRegionPanel();
          panel.hidden = false;
          setRegion(getRegion());
        });
      });
  };

  const fixQuantities = () => {
    document
      .querySelectorAll('input[type="number"][name="quantity"], input[type="number"][name="updates[]"], [data-blacklist-cart-quantity]')
      .forEach((input) => {
        input.max = String(maxQuantity);
        if (!input.min) input.min = input.name === 'updates[]' ? '0' : '1';
        if (input.dataset.blacklistQtyBound === 'true') return;
        input.dataset.blacklistQtyBound = 'true';
        input.addEventListener('input', () => {
          const value = Number(input.value || 0);
          let note = input.parentElement?.querySelector('[data-blacklist-qty-note]');
          if (value > maxQuantity) {
            input.value = String(maxQuantity);
            if (!note) {
              note = document.createElement('small');
              note.setAttribute('data-blacklist-qty-note', '');
              input.parentElement?.appendChild(note);
            }
            note.textContent = `Maximum ${maxQuantity} units per item.`;
          } else if (note) {
            note.remove();
          }
        });
      });
  };

  const fixCartDrawer = () => {
    document.querySelectorAll('.cart-drawer__header, .drawer__header').forEach((header) => {
      if (!header.querySelector('.blacklist-cart-close')) {
        const close = document.createElement('button');
        close.type = 'button';
        close.className = 'blacklist-cart-close';
        close.textContent = 'Close';
        close.addEventListener('click', () => {
          const existing = header.querySelector('.cart-drawer__close-button, .drawer__close, [aria-label*="Close" i]');
          if (existing && existing !== close) {
            existing.click();
            return;
          }
          header.closest('dialog')?.close?.();
          header.closest('[open]')?.removeAttribute('open');
        });
        header.appendChild(close);
      }

      const heading = header.querySelector('.cart-drawer__heading, .drawer__heading, h2, h3');
      if (heading && logoUrl && !heading.querySelector('.blacklist-cart-brandmark')) {
        const img = document.createElement('img');
        img.src = logoUrl;
        img.alt = 'Black List';
        img.className = 'blacklist-cart-brandmark';
        heading.prepend(img);
      }
    });
  };

  const removePromise = () => {
    document.querySelectorAll('summary, h2, h3, h4, p, span, button').forEach((node) => {
      if (!/blacklist['’` ]*s?\s+promise/i.test(node.textContent || '')) return;
      const removable = node.closest('details, .accordion, .collapsible-row, li, article, .product__accordion') || node;
      removable.remove();
    });
  };

  const fixShopLinks = () => {
    document.querySelectorAll('a').forEach((link) => {
      const text = (link.textContent || '').trim().toLowerCase();
      if (text === 'shop all' && !link.href.includes('/pages/shop-all')) {
        link.href = shopAllUrl;
      }
    });
  };

  const run = () => {
    fixInstagram();
    bindRegionLinks();
    fixQuantities();
    fixCartDrawer();
    removePromise();
    fixShopLinks();
  };

  ready(() => {
    run();
    const observer = new MutationObserver(run);
    observer.observe(document.documentElement, { childList: true, subtree: true });
  });
})();
